import { auth } from '../config/firebase';
import { URL_PUBLICA } from '../config/marca';

/**
 * Pide a la función datos-demo que cree o rehaga la cuenta de demo para la
 * revisión de Apple. La contraseña solo hace falta para crearla o cambiarla.
 */
export async function rellenarCuentaDemo(password: string): Promise<{ ok: boolean; mensaje: string }> {
  const usuario = auth.currentUser;
  if (!usuario) return { ok: false, mensaje: 'Vuelve a entrar.' };
  let r: Response;
  try {
    r = await fetch(`${URL_PUBLICA}/.netlify/functions/datos-demo`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${await usuario.getIdToken()}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(password ? { password } : {}),
    });
  } catch (e) {
    return { ok: false, mensaje: `No se ha podido contactar con el servidor (${String(e)}).` };
  }
  try {
    const datos = await r.json();
    return { ok: !!datos.ok, mensaje: datos.mensaje || 'No se ha podido rellenar.' };
  } catch {
    return { ok: false, mensaje: `El servidor ha contestado ${r.status} sin datos: ¿está publicada la función datos-demo?` };
  }
}
